<ng-container *ngFor="let toast of activeToasts">
  <div class="pb-10">
    <ng-template *ngComponentOutlet="
        toast.component;
        injector: toast.injector;
      "></ng-template>
  </div>
</ng-container>
